export default __webpack_public_path__ + "static/media/EpoxyStickingImg.82bfda73.png";